export default (theme) => ({
  loading: {
    marginLeft: '50%',
    marginTop: '100px'
  }
});



// WEBPACK FOOTER //
// ./src/containers/Root/styles.js